// extracted by mini-css-extract-plugin
module.exports = {"shortListGroup":"ShortListGroup_shortListGroup__1dgqN"};